export const TREES = {
    data: [
        {
            label: '书签栏',
            value: '书签栏',
            children: [
                {
                    label: 'React',
                    value: 'React',
                    children: [
                        {
                            label: 'react-dom',
                            value: 'react-dom',
                            children: [
                                {
                                    label: 'findDOMNode()',
                                    value: 'findDOMNode()',
                                },
                                {
                                    label: 'createPortal()',
                                    value: 'createPortal()',
                                },
                            ],
                        },
                        {
                            label: 'react-router',
                            value: 'react-router',
                        },
                        {
                            label: 'react-motion',
                            value: 'react-motion',
                        },
                    ],
                },
                {
                    label: 'CSS3',
                    value: 'CSS3',
                },
            ],
        },
    ],
};
